<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Clientes</h3>
        <router-link class="btn btn-success text-white float-right " :to="{ name: 'admin-customer-new' }">Novo cliente</router-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-3">
              <h6 class="m-0 text-left">
                <span v-if="pagination.trashed">Clientes Deletados</span>
                <span v-else>Clientes Ativos</span>
              </h6>
            </div>
            <div class="col-3">
              Mudar para
              <d-button-group class="ml-4 buttons">
                <d-button :class="['btn text-white float-right', !pagination.trashed? 'btn-danger' : 'btn-success']" @click="toggleTrashed">
                  <span v-if="pagination.trashed">Clientes Ativos</span>
                  <span v-else>Clientes Deletados</span>
                </d-button>
              </d-button-group>
            </div>
            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <customer-table :customers="customers.list" />
            </div>
            <pagination :total-items="customers.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import CustomerTable from '../components/CustomerListTable.vue';

export default {
  name: 'customer-list',
  components: {
    Pagination,
    CustomerTable,
  },
  data() {
    return {
      pagination: {
        trashed: 0,
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    customers() {
      const { customerList } = this.$store.state.customer;
      if (customerList && customerList.list.length) {
        return customerList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getCustomerList',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getCustomerList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    toggleTrashed() {
      this.pagination.trashed = this.pagination.trashed === 1 ? 0 : 1;
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },

};
</script>

<style lang="scss" scoped>
</style>
